import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { isNil } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

interface LoadsCompletedColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const LoadsCompletedColumn = ({ invoice, sx }: LoadsCompletedColumnProps) => {
  const loadsCount = invoice.job?.loadsCount;
  const completedLoadsCount = invoice.jobSummary?.completedLoadsCount;

  const isMissingValues = isNil(loadsCount) || isNil(completedLoadsCount);

  if (isMissingValues) {
    return null;
  }

  return (
    <Box sx={sx}>
      <OverflowAwareText
        sx={{ fontWeight: 700 }}
      >{`${completedLoadsCount} ${t('common.completed')}`}</OverflowAwareText>
      <OverflowAwareText>{`${loadsCount} ${t('dispatch.order.loads')}`}</OverflowAwareText>
    </Box>
  );
};

export default LoadsCompletedColumn;
